import confirmSaga from "./modalSagas";
import { call, put } from "@redux-saga/core/effects";
import {
  setCurrentUser,
  setRequest,
  setSessionTimeOut,
  setURLQueryState,
} from "../../reducers/loginReducer";
import {
  createLogoutRequest,
  createRequest,
  getUser,
  logout,
} from "../requests/loginRequest";
import { handleError } from "../../../util/errorHandler";
import { getAPIConfig } from "../../../util/api-config";
import { SessionApi } from "../../../generated/api";
import store from "../../configureStore";

export function* handleLoginModal(action: any): any {
  const isConfirmed = yield call(confirmSaga, "login");
  if (isConfirmed) {
    console.log("User Signed in");
  }
}

export function* handleSessionTimeOut(): any {
  try {
    const client = new SessionApi(
      getAPIConfig(store.getState().settings.internalSettings)
    );
    const response = yield client.getSessionExpire();

    yield put(setSessionTimeOut(response));
  } catch (error: any) {
    yield handleError(error);
  }
}

export function* handleLoginRequest(action: any): any {
  yield put({ type: "MODAL_CONFIRM" });
  yield put(setCurrentUser(action.params));
}

export function* handleGetUser(action: any): any {
  try {
    const request = yield call(getUser);
    yield put(setCurrentUser(request.data));
  } catch (error: any) {
    if (error?.response?.status === 401 || error?.status === 401) {
      if (window.location.pathname !== "/login") {
        action.history ? action.history("/login") : (window.location.href = "/login");
      }
    }
  }
}

export function* handleCreateRequest(action: any): any {
  const params = action.params;
  const request = yield call(createRequest, params);
  yield put(setRequest(request.data));
}

export function* handleLogout(action: any): any {
  try {
    const response = yield call(createLogoutRequest);
    yield call(logout);
    yield put(setCurrentUser(null));
    yield put(setURLQueryState(null));
    window.location.replace(response.data.logoutRequestUrl);
  } catch (error: any) {
    yield handleError(error);
  }
}

export function* handleURLQuery(action: any) {
  yield put(setURLQueryState(action.state));
}
